import { render } from "./App.vue?vue&type=template&id=948997ea"
const script = {}

import "./App.vue?vue&type=style&index=0&id=948997ea&lang=css"
script.render = render

export default script